var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Title',{attrs:{"title":_vm.$t('main.title'),"description":_vm.$t('main.description')}}),_c('ArticleStream',{attrs:{"items":_vm.$t('main.servicesBullets')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }